import React from 'react'

function TestArea({ label, required, name, value, onChange }) {
    return (
        <div>

            <label htmlFor="message" className=" font-poppins block mb-2 text-sm font-medium text-gray-300">{label}</label>
            <textarea
                name={name}
                value={value}
                required={required}
                onChange={onChange}
                rows="4"
                className="block max-h-[500px] min-h-[20px] p-2.5 w-full  font-poppins text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                placeholder="Write your description here...">

            </textarea>

        </div>
    )
}

export default TestArea